import React, {
  useContext,
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  Suspense,
} from "react";
import { FaEllipsisH } from "react-icons/fa";
import { IoEllipse } from "react-icons/io5";
import { BsGlobe2, BsExclamationDiamondFill } from "react-icons/bs";
import { Context } from "context/context";
import {
  formatDate,
  isImgUrl,
  removePostalCode,
  profileTag,
  currentLang,
  toTitleCase
} from "utils/utils";
import { embedVideo } from "utils/constant";
import ReactPlayer from "react-player";
import _ from "lodash";
import Popup from "reactjs-popup";
import { gsap } from "gsap";
import LazyImage from "./LazyImage";
import { useMilestones } from "redux/modules/milestone/hooks";
import PrivacyBadge from "components/milestonelist/privacyBadge";
import { AiFillPushpin } from "react-icons/ai";
import {
  DATE_NEWEST_TO_OLDEST,
  DATE_OLDEST_TO_NEWEST,
} from "constants/options";
import MediaButton from "components/button/media-button";
import Collapsible from "components/collapsible";
import { CollapsibleToggleButton } from "components/collapsible";
import { useTranslation } from "react-i18next";
import { useDialogHook } from "utils/customhooks";
import PinnedReorder from "./pinned-reorder";
import { CgArrowsExchangeV } from "react-icons/cg";
import { scrollToElementWithOffset } from "./detailed-view";
import { useLocation, useHistory } from 'react-router-dom';
const UserTagIconSVG = React.lazy(() => import("assets/svg/user-tag-icon"));
const Button = React.lazy(() => import("components/button/button"));
const OptionListItem = React.lazy(() =>
  import("./more-option/option-list-item")
);
const AudioPlayer = React.lazy(() => import("./media-button/audio-player"));

const DetailedViewCard = ({
  title,
  dateNote,
  date,
  people,
  url = "",
  viewUrl = "",
  description,
  privacy,
  isAdultContent,
  category,
  buttons = [],
  positions = [],
  platform,
  isYourProfile,
  permission,
  containerStyle = "",
  featured,
  profile,
  onWatchMedia = () => {},
  onViewImage = () => {},
  handleViewPdf = () => {},
  onEdit = () => {},
  onDelete = () => {},
  onReport = () => {},
  onShare = () => {},
  share,
  mention_names={},
  dataId,
  categories=[],
  location="",
  translateMilestone=()=>({milestone:null,section:null,lang:"en"}),
  onCopyLink = () => {},
  onAnalytics = () => {},
  tagView = false,
  onRemoveTag = () => {},
}) => {

  const {translation = {}} = featured;
  const { showMaturedContent, setShowMaturedContent } = useContext(Context);
  const [showMoreOption, setShowMoreOption] = useState();
  const [showAudioPlayer, setShowAudioPlayer] = useState(false);
  const [showAllMedia, setShowAllMedia] = useState(false);
  const [isVisible, setIsVisible] = useState(-1);
  const [hideMusic, setHideMusic] = useState(false);
  const [desc, setDescription] = useState(() => {
      const lang = currentLang();
      const t = translation?.[lang];
      return t?.description || description;
    });
  const listenRef = useRef();
  const optionRef = useRef();
  const { http } = global.services;

  const loc = useLocation();
  const history = useHistory();
  const {t} = useTranslation();


  useEffect(() => {
    const search = new URLSearchParams(loc.search);
    const focusMiletone = search.get("focusMilestone");
    if(focusMiletone) {
      const targetId = Number(focusMiletone);
      const currentId = Number(dataId);
      if(targetId === currentId) {
        const element = document.querySelector(`[data-milestone-id="${targetId}"]`);
        // element.scrollIntoView();
        scrollToElementWithOffset(element, 120); // scroll with 50px top space
        const pathWithoutSearch = loc.pathname;
        history.replace(pathWithoutSearch);
      }
    }
  }, [loc, dataId, history]);

  const img = new Image();
  img.onload = function () {
  };
  img.src = url;

  useEffect(() => {
    if (!_.isEmpty(mention_names)) {
      let newDesc = profileTag(mention_names, description);
      setDescription(newDesc);
    }else{
      setDescription(() => {
          const lang = currentLang();
          const t = translation?.[lang];
          return t?.description || description;
        });
    }
  }, [description, mention_names,translation]);

  useEffect(() => {
    window.addEventListener(
      "scroll",
      () => {
        // if (listenRef.current) {
        //   setHideMusic(true);
        // }
        if (optionRef.current) {
          optionRef.current.close();
        }
      },
      true
    );
  }, []);

  useLayoutEffect(() => {
    gsap.fromTo(
      ".milestone-item",
      {
        y: 20,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
      }
    );
  }, []);

  const handleMedia = async (media) => {
    http.post(`button-click/`, { id: media.id });
    let url = "";
    let orientation = "Landscape";
    let fileExt = "";

    if (
      media.sub_type.name === "Multiple Images" ||
      media.sub_type.name === "Single Image"
    ) {
      onViewImage(title, media, media["media"]);
    } else {
      if (media.url) {
        url = media.url;
        orientation = media?.orientation;
      } else {
        url = media["media"][0]["media"]["url"];
        orientation = media["media"][0]["media"]["orientation"];
        fileExt = media["media"][0]["media"]["file_extension"];
      }

      if (await isImgUrl(url)) {
        onViewImage(title, media, media["media"]);
      } else if (ReactPlayer.canPlay(url)) {
        onWatchMedia(title, url, orientation);
      } else if (fileExt === "pdf") {
        handleViewPdf(title, url,media["media"], media);
      } else {
        if (embedVideo.find((v) => url.includes(v.value))) {
          onWatchMedia(title, url, orientation);
        } else {
          window.open(url, "_blank");
        }
      }
    }
  };

  return (
    <Suspense>
      <div
        className={`milestone-item w-full bg-siteBg md:rounded-md ${containerStyle}`}
        data-milestone-id={dataId || "no-id"}
      >
        <div className="w-full flex flex-col space-y-0.5">
          {
            url && (
              <div className="relative bg-white h-fit w-full">
                {/* thumbnail */}
                <LazyImage
                  viewUrl={viewUrl}
                  source={url}
                  customClassName="w-full"
                />
                {/* restricted Image */}
                {/* {!isAdultContent && !showMaturedContent && (
                <div className="absolute top-0 left-0 matured-content-blured">
                  <div className="w-full px-6 text-center">
                    <div className="flex justify-center">
                      <BsExclamationDiamondFill className="text-5xl" />
                    </div>
                    <h3 className="mt-4.5 font-bold text-lg">Mature Content</h3>
                    <p className="mt-4 text-sm font-medium hidden sm:block">
                      You must be 18+ to view this image. Are you over eighteen
                      and willing to see adult content?
                    </p>
                    <Button
                      buttonName="Continue"
                      buttonTextClass="text-sm text-white font-semibold"
                      buttonRadius="6px"
                      buttonClass="relative py-4 px-11 bg-transparent border-2 border-white mt-5.5"
                      onClick={() => setShowMaturedContent((prev) => !prev)}
                    />
                  </div>
                </div>
              )} */}
              </div>
            )
            // <div className="relative w-full h-[600px] flex items-center justify-center bg-[#e9e9e9]">
            //     <div className="w-full  flex items-center justify-center h-full bg-[#e9e9e9]">
            //       <img src={CoverPlaceholderMilestone} alt="Milestone" className="w-[200px]"/>
            //     </div>
            // </div>
          }

          <div className="relative w-full bg-white 2md:mt-0 py-10 px-7.5 3md:p-10">
            <div className="w-full flex 1sm:hidden justify-end">
              <button className="bg-thBg w-10 h-10 rounded-md">
                <FaEllipsisH className="m-auto" />
              </button>
            </div>
            {/* content */}
            <div className="w-full 1sm:flex 1sm:justify-between">
              <div className="w-full">
                {/* title */}
                <div className="flex items-center space-x-5 flex-wrap">
                  <p className="text-4xl text-lightBlack font-medium tracking-tighter">
                    {toTitleCase(translation?.[currentLang()]?.[title] || title)}
                  </p>
                </div>
                {/* category */}
                {/* <div className="flex items-center space-x-5 flex-wrap mt-1">
                  <p className="px-4.5 py-1.5 bg-lightGreen text-white text-xs uppercase font-semibold rounded-md">
                    {category}
                  </p>
                </div> */}
                <div className="inline-flex flex-wrap gap-2">
                      {
                        categories.map((item,index)=>{
                          return(
                              <p key={index} 
                              style={{ 
                                ...(isAdultContent && {
                                  marginLeft: 0
                                })
                              }}
                              className="px-1.5 py-1 3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md items-center justify-center">
                                {(!profile?.dateFormat && item[currentLang()] === 'Theatre') ? 'Theater' : item[currentLang()] ||item.name}
                              </p>
                          )
                        })
                      }
                    </div>
                {/* details */}
                <div className="w-full mt-2">
                  <div className="w-full text-darkerGray font-medium leading-6 flex items-center gap-x-3 gap-y-1 flex-wrap">
                    <div className="item-col-lg">
                      <p>
                        {date}
                        {dateNote && (
                          <span className="ml-1">{`(${translation?.[currentLang()]?.[dateNote] || dateNote})`}</span>
                        )}
                      </p>
                    </div>
                    {
                      isYourProfile && 
                      <div className="item-col-lg">
                        <PrivacyBadge
                          privacy={privacy}
                          isYourProfile={isYourProfile}
                        /> 
                      </div>
                    }
                    {isAdultContent && (
                      <div className="item-col-lg">
                        <span className="text-red flex flex-row items-center font-medium">
                          <BsExclamationDiamondFill className="mr-1.5" /> {t('adultContent')}
                        </span>
                      </div>
                    )}
                    {/* <p className="flex items-center capitalize">
                      {privacy === "public" ? (
                        <BsGlobe2 className="mr-1.5" />
                      ) : (
                        <BsExclamationDiamondFill className="mr-1.5" />
                      )}
                      {privacy}
                    </p> */}
                    {people && (
                      <div className="item-col-lg">
                        {/* <p className="hidden md:block">
                          <IoEllipse className="w-1 h-1" />
                        </p> */}
                        <p className="hidden md:flex items-center">
                          <UserTagIconSVG className="mr-1.5" />
                          {people}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                {/* Author Name and description */}
                <div className="w-full mt-1.5">
                  <p className="text-base font-bold leading-6">
                    {/* {positions.map((p, i) => (
                      <span key={i}>
                        {p.position.name}
                        {p.description && ` - ${removePostalCode(p.description)} `}
                        {i < positions.length - 1 && ", "}
                      </span>
                    ))} */}
                    <span>
                      {positions
                        .map((p) => {
                          const _pos = [p.position[currentLang()]?.trim() || p.position.name?.trim()];
                          if (p.description)
                            _pos.push(removePostalCode(p.description).trim());
                          return _pos.join(" - ");
                        })
                        .join(", ")
                        .trim()}
                    </span>
                    <span className="pl-[0.15rem]">
                      {platform && (
                        <>
                          (
                          {translation?.[currentLang()]?.[platform] || platform}
                          {(location && location !== 'null') && ` - ${translation?.[currentLang()]?.[location] || location}`}
                          )
                        </>
                      )}
                      </span>
                  </p>
                  <p
                    className="mt-1 tracking-tightest html-content text-[13px] 2sm:text-sm 3md:text-base leading-5 2sm:leading:5"
                    dangerouslySetInnerHTML={{
                      __html:
                        description === "null" || !description ? "" : desc,
                    }}
                  ></p>
                  {/* <p className="mt-2.5 text-base leading-7.5 tracking-tightest text-darkerGray" dangerouslySetInnerHTML={{__html: this.state.content}}>
                  {description}
                </p> */}
                </div>
                {/* buttons */}
                {!_.isEmpty(buttons) && (
                  <div className="w-full my-4">
                    <div className="w-full grid 2md:grid-cols-2 gap-4">
                      {buttons
                        .slice(0, showAllMedia ? buttons.length : 2)
                        .map((btn, index) => {
                          if (btn.type.name === "Listen") {
                            return (
                              <div className="relative">
                                <MediaButton
                                  key={index}
                                  buttonName={btn?.translation?.[currentLang()]?.[btn.label] || btn.label}
                                  buttonTextClass={`text-xs 2md:text-sm text-lightBlack font-semibold`}
                                  buttonRadius="6px"
                                  buttonClass={`relative rounded-md py-2 px-4 2sm:px-10 2md:px-4 lg:py-3 xl:px-0 border-2 border-gray btn-hover-white-primary bg-white w-full h-full`}
                                  onClick={() => {
                                    setIsVisible(buttons.id);
                                  }}
                                />
                                {isVisible === buttons.id && (
                                  <div
                                    className="absolute -top-[4rem] z-[9999] left-0 insert-0"
                                    ref={listenRef}
                                  >
                                    <AudioPlayer
                                      media={btn}
                                      hide={hideMusic}
                                      onClosePlayer={() => {
                                        setIsVisible(null);
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            );
                          }

                          return (
                            <MediaButton
                              key={index}
                              buttonName={btn?.translation?.[currentLang()]?.[btn.label] || btn.label}
                              buttonData={btn}
                              buttonTextClass={`text-xs 2md:text-sm text-lightBlack font-semibold`}
                              buttonRadius="6px"
                              buttonClass={`relative rounded-md py-2 px-4 2sm:px-10 2md:px-4 lg:py-3 xl:px-0 border-2 border-gray btn-hover-white-primary bg-white w-full h-full`}
                              onClick={() => handleMedia(btn)}
                            />
                          );
                        })}
                    </div>
                  </div>
                )}
                {buttons.length > 2 && (
                  <button
                    className={`w-full h-12 rounded-md ${
                      showAllMedia ? "bg-lightBlack text-white" : "bg-thBg"
                    }`}
                    onClick={() => setShowAllMedia(!showAllMedia)}
                  >
                    {showAllMedia ? t("hide") : `+${buttons.length - 2} ${t('more')}`}
                  </button>
                )}
              </div>
              {/* more */}
              <Popup
                ref={optionRef}
                position="bottom right"
                open={showMoreOption}
                onClose={() => setShowMoreOption(false)}
                arrow={false}
                contentStyle={{ marginTop: 10, marginLeft: 5 }}
                trigger={
                  <button
                    className="bg-thBg w-10 h-10 rounded-md hidden 1sm:block"
                    onClick={() => setShowMoreOption((open) => !open)}
                  >
                    <FaEllipsisH className="m-auto" />
                  </button>
                }
              >
                <OptionListItem
                  {...{
                    isYourProfile,
                    onEdit,
                    onDelete,
                    permission,
                    onReport,
                    featured,
                    profile,
                    onShare,
                    share,
                    translateMilestone,
                    onAnalytics,
                    onCopyLink,
                    tagView,
                    onRemoveTag
                  }}
                  closeMoreOption={() => {
                    setShowMoreOption(false);
                    optionRef.current.close();
                  }}
                />
              </Popup>
            </div>
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default function DetailedViewMilestones({
  isYourProfile,
  featured = {},
  profile,
  current = [],
  past = [],
  pin = [],
  upcoming = [],
  showFeatured,
  permission,
  onWatchMedia = () => {},
  onViewImage = () => {},
  handleViewPdf = () => {},
  onEdit = () => {},
  onDelete = () => {},
  onReport = () => {},
  onShare = () => {},
  milestone_owner,
  translateMilestone=()=>({milestone:null,section:null,lang:"en"}),
  onCopyLink = () => {},
  onAnalytics = () => {},
}) {
  const {t} = useTranslation();
  const pinnedOrder =useDialogHook(PinnedReorder)
  const { organizeBy } = useMilestones();
  const featuredThumbnail = featured.thumbnail
    ? featured.thumbnail.webp_url || featured.thumbnail.url
    : null;
  const featuredDate = formatDate(featured, profile?.dateFormat,t);

  useLayoutEffect(() => {
    gsap.fromTo(
      ".milestone-title",
      {
        y: -20,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
      }
    );
  }, []);

  const customHandle = ()=>{ 
    pinnedOrder({milestones:pin,profile},(callback)=>{
      if(callback?.success){
        return;
      }
    })
  }

  return (
    <Suspense>
      <div className="w-full">
        {showFeatured && (
          <div className="w-full">
            {!_.isEmpty(featured) && (
              <DetailedViewCard
                dataId={featured.id}
                profile={profile}
                featured={featured}
                url={featuredThumbnail}
                viewUrl={featured?.thumbnail?.url || null}
                title={featured.title}
                dateNote={featured.date_note}
                date={featuredDate}
                people={featured.people}
                positions={featured.positions}
                platform={featured.platform}
                description={featured.description}
                privacy={featured.privacy}
                isAdultContent={featured.is_adult_content ? true : false}
                // category={featured?.category?.name}
                buttons={featured.media_type}
                onWatchMedia={onWatchMedia}
                onViewImage={onViewImage}
                handleViewPdf={handleViewPdf}
                onEdit={() => onEdit(featured, "featured")}
                onDelete={() => onDelete(featured)}
                isYourProfile={isYourProfile}
                permission={permission}
                onShare={() => onShare(featured, "featured")}
                share={true}
                categories={featured.categories}
                location={featured.location}
                onReport={() => onReport({...featured, profile:milestone_owner})}
                onCopyLink={() => onCopyLink(featured)}
                onAnalytics={() => onAnalytics(featured)}
              />
            )}
          </div>
        )}
        <div className="w-full">
          <Collapsible
            hidden={pin.length === 0}
            hideButton={true}
            title={({ toggle, open }) => (
              <>
                {pin.length > 0 && (
                  <div className="p-5 flex flex-row items-center gap-4 ">
                    <CollapsibleToggleButton toggle={toggle} open={open} />
                    <p className="milestone-title text-lightBlack font-bold text-base 2sm:text-xl 3md:text-2xl leading-7.5 tracking-tighter flex gap-3">
                      <>{t("pinned")}</>
                      <AiFillPushpin className="text-2xl" />
                    </p>
                    {
                      isYourProfile && 
                      (
                        <Button
                          icon={<CgArrowsExchangeV className="text-sm"/>}
                          buttonName={t("reorder_pinned")}
                          buttonRadius="6px"
                          iconPosition="left"
                          buttonClass="py-2 px-4 bg-gray"
                          buttonTextClass="text-black text-sm font-semibold flex items-center justify-center"
                          onClick={() => customHandle()}
                        /> 
                      )
                    }
                    
                  </div>
                )}
              </>
            )}
            content={() => (
              <>
                {pin.map((obj, index) => {
                  const date = formatDate(obj, profile?.dateFormat,t);
                  const thumbnail = obj.thumbnail
                    ? obj.thumbnail.webp_url || obj.thumbnail.url
                    : null;
                  return (
                    <DetailedViewCard
                      dataId={obj.id}
                      profile={profile}
                      featured={obj}
                      containerStyle="mt-3"
                      key={`past-${index}-${obj.id}`}
                      details={obj}
                      url={thumbnail}
                      viewUrl={obj?.thumbnail?.url || null}
                      title={obj.title}
                      dateNote={obj.date_note}
                      date={date}
                      people={obj.people}
                      positions={obj.positions}
                      platform={obj.platform}
                      description={obj.description}
                      privacy={obj.privacy}
                      isAdultContent={obj.is_adult_content ? true : false}
                      // category={obj?.category?.name}
                      buttons={obj.media_type}
                      onWatchMedia={onWatchMedia}
                      onViewImage={onViewImage}
                      handleViewPdf={handleViewPdf}
                      onEdit={() => onEdit(obj, "pin")}
                      onDelete={() => onDelete(obj, "pin")}
                      isYourProfile={isYourProfile}
                      permission={permission}
                      onShare={() => onShare(obj, "pin")}
                      share={true}
                      mention_names={obj.mention_names}
                      categories={obj.categories}
                      location={obj.location}
                      onReport={() => onReport({...obj, profile:milestone_owner})}
                      translateMilestone = {translateMilestone}
                      onCopyLink={() => onCopyLink(obj)}
                      onAnalytics={() => onAnalytics(obj)}
                    />
                  );
                })}
              </>
            )}
          />
        </div>
        <div className="w-full mt-5">
          <Collapsible
            hidden={upcoming.length === 0}
            hideButton={true}
            title={({ toggle, open }) => (
              <>
                {upcoming.length > 0 && (
                  <div
                    className={` p-5 flex flex-row items-center gap-4 ${
                      showFeatured && "mt-10"
                    }`}
                  >
                    <CollapsibleToggleButton toggle={toggle} open={open} />
                    <p className="milestone-title px-2 3md:px-0 text-lightBlack font-bold text-2xl leading-7.5 tracking-tighter">
                      {organizeBy === DATE_NEWEST_TO_OLDEST
                        ? DATE_NEWEST_TO_OLDEST
                        : organizeBy === DATE_OLDEST_TO_NEWEST
                        ? DATE_OLDEST_TO_NEWEST
                        : t("upcoming")}
                      {/* Upcoming */}
                    </p>
                  </div>
                )}
              </>
            )}
            content={() => (
              <>
                {upcoming.map((obj, index) => {
                  const date = formatDate(obj, profile?.dateFormat,t);
                  const thumbnail = obj.thumbnail
                    ? obj.thumbnail.webp_url || obj.thumbnail.url
                    : null;

                  return (
                    <DetailedViewCard
                      dataId={obj.id}
                      profile={profile}
                      featured={obj}
                      containerStyle="mt-3"
                      key={`upcoming-${index}-${obj.id}`}
                      details={obj}
                      url={thumbnail}
                      viewUrl={obj?.thumbnail?.url || null}
                      title={obj.title}
                      dateNote={obj.date_note}
                      date={date}
                      people={obj.people}
                      positions={obj.positions}
                      platform={obj.platform}
                      description={obj.description}
                      privacy={obj.privacy}
                      isAdultContent={obj.is_adult_content ? true : false}
                      // category={obj?.category?.name}
                      buttons={obj.media_type}
                      onWatchMedia={onWatchMedia}
                      onViewImage={onViewImage}
                      handleViewPdf={handleViewPdf}
                      onEdit={() => onEdit(obj, "upcoming")}
                      onDelete={() => onDelete(obj,"upcoming")}
                      isYourProfile={isYourProfile}
                      permission={permission}
                      onShare={() => onShare(obj, "upcoming")}
                      share={true}
                      mention_names={obj.mention_names}
                      categories={obj.categories}
                      location={obj.location}
                      onReport={() => onReport({...obj, profile:milestone_owner})}
                      translateMilestone = {translateMilestone}
                      onCopyLink={() => onCopyLink(obj)}
                      onAnalytics={() => onAnalytics(obj)}
                    />
                  );
                })}
              </>
            )}
          />
        </div>
        <div className="w-full mt-5">
          <Collapsible
            hidden={current.length === 0}
            hideButton={true}
            title={({ toggle, open }) => (
              <>
                {current.length > 0 && (
                  <div
                    className={` p-5 flex flex-row items-center gap-4 ${
                      showFeatured && "mt-10"
                    }`}
                  >
                    <CollapsibleToggleButton toggle={toggle} open={open} />
                    <p className="milestone-title px-2 3md:px-0 text-lightBlack font-bold text-2xl leading-7.5 tracking-tighter">
                      {organizeBy === DATE_NEWEST_TO_OLDEST
                        ? DATE_NEWEST_TO_OLDEST
                        : organizeBy === DATE_OLDEST_TO_NEWEST
                        ? DATE_OLDEST_TO_NEWEST
                        : t("current")}
                      {/* current */}
                    </p>
                  </div>
                )}
              </>
            )}
            content={() => (
              <>
                {current.map((obj, index) => {
                  const date = formatDate(obj, profile?.dateFormat,t);
                  const thumbnail = obj.thumbnail
                    ? obj.thumbnail.webp_url || obj.thumbnail.url
                    : null;

                  return (
                    <DetailedViewCard
                      dataId={obj.id}
                      profile={profile}
                      featured={obj}
                      containerStyle="mt-3"
                      key={`current-${index}-${obj.id}`}
                      details={obj}
                      url={thumbnail}
                      viewUrl={obj?.thumbnail?.url || null}
                      title={obj.title}
                      dateNote={obj.date_note}
                      date={date}
                      people={obj.people}
                      positions={obj.positions}
                      platform={obj.platform}
                      description={obj.description}
                      privacy={obj.privacy}
                      isAdultContent={obj.is_adult_content ? true : false}
                      // category={obj?.category?.name}
                      buttons={obj.media_type}
                      onWatchMedia={onWatchMedia}
                      onViewImage={onViewImage}
                      handleViewPdf={handleViewPdf}
                      onEdit={() => onEdit(obj, "current")}
                      onDelete={() => onDelete(obj,"current")}
                      isYourProfile={isYourProfile}
                      permission={permission}
                      onShare={() => onShare(obj, "current")}
                      share={true}
                      mention_names={obj.mention_names}
                      categories={obj.categories}
                      location={obj.location}
                      onReport={() => onReport({...obj, profile:milestone_owner})}
                      translateMilestone = {translateMilestone}
                      onCopyLink={() => onCopyLink(obj)}
                      onAnalytics={() => onAnalytics(obj)}
                    />
                  );
                })}
              </>
            )}
          />
        </div>
        <div className="w-full mt-10">
          <Collapsible
            hidden={past.length === 0}
            hideButton={true}
            title={({ toggle, open }) => (
              <>
                {past.length > 0 ? (
                  organizeBy === DATE_NEWEST_TO_OLDEST ||
                  organizeBy === DATE_OLDEST_TO_NEWEST ? (
                    <></>
                  ) : (
                    <div className="p-5 flex flex-row items-center gap-4">
                      <CollapsibleToggleButton toggle={toggle} open={open} />
                      <p className="milestone-title px-2 3md:px-0 text-lightBlack font-bold text-2xl leading-7.5 tracking-tighter">
                        {t("previous")}
                      </p>
                    </div>
                  )
                ) : (
                  <></>
                )}
              </>
            )}
            content={() => (
              <>
                {past.map((obj, index) => {
                  const date = formatDate(obj, profile?.dateFormat,t);
                  const thumbnail = obj.thumbnail
                    ? obj.thumbnail.webp_url || obj.thumbnail.url
                    : null;
                  return (
                    <DetailedViewCard
                      dataId={obj.id}
                      profile={profile}
                      featured={obj}
                      containerStyle="mt-3"
                      key={`past-${index}-${obj.id}`}
                      details={obj}
                      url={thumbnail}
                      viewUrl={obj?.thumbnail?.url || null}
                      title={obj.title}
                      dateNote={obj.date_note}
                      date={date}
                      people={obj.people}
                      positions={obj.positions}
                      platform={obj.platform}
                      description={obj.description}
                      privacy={obj.privacy}
                      isAdultContent={obj.is_adult_content ? true : false}
                      // category={obj?.category?.name}
                      buttons={obj.media_type}
                      onWatchMedia={onWatchMedia}
                      onViewImage={onViewImage}
                      handleViewPdf={handleViewPdf}
                      onEdit={() => onEdit(obj, "past")}
                      onDelete={() => onDelete(obj,"past")}
                      isYourProfile={isYourProfile}
                      permission={permission}
                      onShare={() => onShare(obj, "past")}
                      share={true}
                      mention_names={obj.mention_names}
                      categories={obj.categories}
                      location={obj.location}
                      translateMilestone = {translateMilestone}
                      onCopyLink={() => onCopyLink(obj)}
                      onAnalytics={() => onAnalytics(obj)}
                    />
                  );
                })}
              </>
            )}
          />
        </div>
      </div>
    </Suspense>
  );
}

export { DetailedViewCard };
